export const MESSAGE_TYPES = {
  VISIT: { collection: "visits" },
  RESERVATION: { collection: "reservations" }
};
